import { showErrorToast, showSuccessToast } from '@bpinternal/ui-kit-next'
import { useMutation } from '@tanstack/react-query'
import { logout } from '~/services'
import { handleHttpErrors } from '../../shared'
import { getApiClient } from '../../stores'

export function useDeleteAccount() {
  return useMutation({
    mutationFn: async () => {
      return await getApiClient().deleteAccount({}).catch(handleHttpErrors)
    },
    onSuccess: () => {
      showSuccessToast(
        'Your account has been deleted successfully. You will be redirected to the login page in 5 seconds.'
      )
      setTimeout(() => {
        logout()
      }, 5000)
    },
    onError: (error: Error) => {
      showErrorToast(error.message)
    },
  })
}
